import {Routes, Route, useNavigationType, useLocation} from "react-router-dom";
import React, {useEffect} from "react";
import * as pages from "pages/client";
import {ScreenId} from "@assets";
import {useSetRecoilState} from "recoil";
import {states} from "@recoils";

interface IRoute {
  path: ScreenId;
  element: JSX.Element;
}

const initRouteList: IRoute[] = [
  {path: ScreenId.HOME, element: <pages.HomePage />},
  {path: ScreenId.REVIEW, element: <pages.ReviewPage />},
];

export default function WebRouteApp() {
  const location = useLocation();
  const setPathState = useSetRecoilState(states.pathState);

  useEffect(() => {
    setPathState(location.pathname as ScreenId);
  }, [location.pathname]);

  return (
    <Routes>
      <Route
        path="/"
        element={(initRouteList || [])[0]?.element || <pages.HomePage />}
      />
      {initRouteList.map((_route, i) => (
        <Route key={i} path={_route.path} element={_route.element} />
      ))}
      <Route path="*" element={<pages.HomePage />} />
    </Routes>
  );
}
